// extracted by mini-css-extract-plugin
module.exports = {"si9hqdm":"si9hqdm","locked":"locked","premium-icon":"premium-icon"};